import styled from '@emotion/styled';
import CommonStyledComponents from 'shared/styles/CommonStyledComponents';
import { useSelector } from 'react-redux';

import PageLayout from 'components/PageLayout';

const { Area } = CommonStyledComponents;

export default function FloorImgPage() {
  const { content } = useSelector(state => state.place.placeDetails.place);

  return (
    <FloorImgPageContainer>
      <PageLayout title="도면보기" backBtn>
        <Area>
          {content ? (
            <div
              className={'ck-content'}
              dangerouslySetInnerHTML={{ __html: content }}
            ></div>
          ) : null}
        </Area>
      </PageLayout>
    </FloorImgPageContainer>
  );
}

const FloorImgPageContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 10000;
`;
